'use strict';

require('./index.less'); // eslint-disable-line